import { forwardRef, useState, useCallback } from 'react';
import { FiEye, FiEyeOff, FiLock } from 'react-icons/fi';

import Field, { FieldProps } from '../field';

const PasswordField = forwardRef<HTMLInputElement, FieldProps>((props, ref) => {
  const [inputType, setInputType] = useState('password');

  const handleClick = useCallback(() => {
    setInputType((prev) => (prev === 'password' ? 'text' : 'password'));
  }, []);

  return (
    <Field
      rightIcon={inputType === 'password' ? FiEye : FiEyeOff}
      onRightIconClick={handleClick}
      leftIcon={FiLock}
      type={inputType}
      ref={ref}
      {...props}
    />
  );
});

PasswordField.displayName = 'PasswordField';

export default PasswordField;
